import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { FormGroup, Label, Flex, Divider } from '@sopranodesign/pulse-components';
import { useLanguages } from '@sopranodesign/pulse-hooks';
import { isRTLLanguageById } from '@sopranodesign/pulse-volt';

import { useComposer } from '../../hooks/index';
import ComposerContent from './ComposerContent';
import TypeSelect from './TypeSelect';
import ComposerSelect from './ComposerSelect';

const Composer = () => {
  const {
    dispatch,
    response: { type, composer, language_id }
  } = useComposer();

  const { languages } = useLanguages();

  const rtl = isRTLLanguageById(languages, language_id);

  const handleTypeChange = ({ value }) => {
    dispatch({ type: 'CHANGE_TYPE', newType: value });
  };

  const handleComposerChange = useCallback(
    ({ value }) => {
      dispatch({ type: 'CHANGE_COMPOSER', newComposer: value });
    },
    [dispatch]
  );

  return (
    <>
      <Flex xSpaceSm fat>
        <Flex col fat>
          <Label htmlFor="response-type">Message Type</Label>
          <TypeSelect
            id="response-type"
            aria-label="response-type"
            value={type}
            onChange={handleTypeChange}
          />
        </Flex>
        <Flex col fat>
          <Label htmlFor="composer">Composer</Label>
          <ComposerSelect
            id="composer"
            aria-label="composer"
            value={composer}
            onChange={handleComposerChange}
          />
        </Flex>
      </Flex>
      <Divider />
      <FormGroup>
        <ComposerContent rtl={rtl} />
      </FormGroup>
    </>
  );
};

Composer.propTypes = {
  rtl: PropTypes.oneOf(['rtl', 'ltr'])
};

export default Composer;
